import { css } from "styled-components";
import { ITheme } from "../../Theme/Theme.types.js";
import { DefaultButtonProps } from "../Button.types.js";

function isShadowColor(theme: Pick<ITheme, "shadows">, color: string): color is keyof typeof theme.shadows.focus {
    return Object.keys(theme.shadows.focus).includes(color);
}

export const getFocusRing = ({ color, theme }: Pick<DefaultButtonProps, "color"> & { theme: ITheme }) => css`
    box-shadow: ${() => {
        if (!isShadowColor(theme, color)) return theme.shadows.focus.neutral;

        return theme.shadows.focus[color];
    }};
`;
